import React from 'react';
import Typo from '../typo';

const MatchCardInfo = ({ transKey, title }) => {
  return (
    <>
      <Typo transKey={transKey} component='p' className='si-matchCardInfo'>
        {/* {title} */}
      </Typo>
    </>
  );
};

export default MatchCardInfo;
